import { Stack, Typography } from "@mui/material";
export type CardType = {
	icon?: React.ReactElement;
	title: string;
	digits: string;
	bgcolor: string;
	onClick?: () => void;
};

interface TopCardsProps {
	cards: CardType[];
}

export function TopCardsSmall({ cards }: TopCardsProps) {
	return (
		<Stack direction="row" gap={1} flexWrap="wrap">
			{cards.map((card: CardType, i) => (
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="center"
					bgcolor={`${card.bgcolor}.light`}
					onClick={() => card.onClick?.()}
					borderRadius="8px"
					gap={1}
					key={card.title + i}
					p={0.5}
					sx={{
						cursor: "pointer",
						transition: "all 0.25s ease",
						boxShadow: (t) => `0 0 0 0 ${t.palette[card.bgcolor].light}44`,
						"&:hover": {
							boxShadow: (t) => `0 0 6px 0px ${t.palette[card.bgcolor].main}88`,
						},
					}}
				>
					<Typography
						color={`${card.bgcolor}.main`}
						variant="subtitle1"
						fontWeight={600}
						textAlign="center"
					>
						{card.title} ({card.digits})
					</Typography>
				</Stack>
			))}
		</Stack>
	);
}
